import type { ICarbucksGuaranteeFeature, ICarbucksGuaranteeFeatureDto } from "./ICarbucksGuaranteeFeature";

export class CarbucksGuaranteeFeature implements ICarbucksGuaranteeFeature
{

    isEnabledInAppSettings: boolean;
    title: string;

    constructor( model: ICarbucksGuaranteeFeatureDto )
    {
        this.title = model.title;
        this.isEnabledInAppSettings = model.isEnabledInAppSettings;
    }

    /**
     * True if the feature is enabled
     */
    get isEnabled()
    {
        return this.isEnabledInAppSettings;
    }
    
}